var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import Dropdown from "react-bootstrap/Dropdown";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { UxAction, UxIconEnum, UxSizeEnum, UxPriorityEnum, eventHelper } from "@imaginelearning/mps-ux-component-library";
import { defaultLanguages, moreLanguages } from "./languages-list";
var getLanguages = function (isShow) {
    var languages = __spreadArray([], defaultLanguages, true);
    if (isShow) {
        var copyMoreLanguages = __spreadArray([], moreLanguages, true);
        languages.splice(languages.length - 1, 1);
        copyMoreLanguages.splice(0, 1);
        copyMoreLanguages.sort(function (a, b) {
            if (a.name < b.name)
                return -1;
            if (a.name > b.name)
                return 1;
            return 0;
        });
        var less = moreLanguages.find(function (language) { return language.name.toLowerCase() === "less"; });
        copyMoreLanguages.unshift(less);
        languages = __spreadArray(__spreadArray([], languages, true), copyMoreLanguages, true);
    }
    return languages;
};
function TranslationDropdown(props) {
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    var languageChangeCallback = props.languageChangeCallback, languageSelected = props.languageSelected;
    var language = defaultLanguages.find(function (lang) { return lang.googleAbbr === languageSelected; }) || defaultLanguages[0];
    if (languageSelected) {
        language = getLanguages(true).find(function (language) { return language.googleAbbr === languageSelected; });
    }
    var _b = useState(false), showLanguageDropdown = _b[0], setShowLanguageDropdown = _b[1];
    var _c = useState(__spreadArray([], defaultLanguages, true)), languageList = _c[0], setLanguageList = _c[1];
    var _d = useState(false), showMoreLanguages = _d[0], setShowMoreLanguages = _d[1];
    var _e = useState(language), selectedLanguage = _e[0], setSelectedLanguage = _e[1];
    var languageDropdown = React.forwardRef(function (languageDropdownProps, ref) { return (React.createElement(OverlayTrigger, { key: "bottom", placement: "bottom", overlay: React.createElement(Tooltip, { id: "tooltip-bottom" }, t("Language Translation")) },
        React.createElement("div", __assign({}, languageDropdownProps, eventHelper(languageDropdownProps.onClick, { tabIndex: 0 }), { ref: ref, className: "selected-language-wrapper d-flex align-items-center" }),
            React.createElement(UxAction, { enabled: true, priority: UxPriorityEnum.INFO, callback: function () { return setShowLanguageDropdown(!showLanguageDropdown); }, icon: {
                    title: "Language",
                    icon: UxIconEnum.LANGUAGE_TRANSLATION,
                    size: UxSizeEnum.LARGE
                }, className: "me-n3", text: selectedLanguage.nativeName })))); });
    var onShowHideMoreLanguagesClick = function (isShow) {
        setShowMoreLanguages(isShow);
        var languages = getLanguages(isShow);
        setLanguageList(__spreadArray([], languages, true));
    };
    return (React.createElement("div", { className: "language-container", "data-no-translate": true },
        React.createElement(Dropdown, { show: showLanguageDropdown },
            React.createElement(Dropdown.Toggle, { as: languageDropdown, id: "language-dropdown" }),
            React.createElement(Dropdown.Menu, null,
                selectedLanguage && (React.createElement(Dropdown.Item, { key: selectedLanguage.index, title: selectedLanguage.name, className: "active-language" }, t(selectedLanguage.nativeName))),
                languageList.map(function (item, index) {
                    return item.name === "More" || item.name === "Less" ? (React.createElement(Fragment, { key: item.name },
                        React.createElement(Dropdown.Divider, null),
                        React.createElement(Dropdown.Item, { key: index, onClick: function () { return onShowHideMoreLanguagesClick(!showMoreLanguages); } }, t(item.nativeName)))) : (selectedLanguage &&
                        item.name !== selectedLanguage.name && (React.createElement(Dropdown.Item, { key: item.name, title: item.name, onClick: function () {
                            setSelectedLanguage(item);
                            setShowLanguageDropdown(false);
                            onShowHideMoreLanguagesClick(false);
                            languageChangeCallback(item);
                        } }, t(item.nativeName))));
                })))));
}
export default TranslationDropdown;
